(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var gutterStable = !!(window.CSS && CSS.supports && CSS.supports('scrollbar-gutter', 'stable'));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);

  function boot() {
    document.querySelectorAll('[data-wtt-app]').forEach(initApp);
  }

  function initApp(app) {
  if (app.hasAttribute('data-wtt-wired')) return;
  app.setAttribute('data-wtt-wired', '');
  var root0 = app.closest('.us-wtt2');
  var P = window.US_PANEL;
  if (!P || !P.categories) {
    app.innerHTML = '';
    var err = document.createElement('p');
    err.className = 'us-wtt2__loading';
    err.textContent = 'The panel couldn’t be loaded. Please refresh the page to try again.';
    app.appendChild(err);
    return;
  }

  var condDesc = P.conditionDescriptions || {};
  var ICONS = window.US_CATEGORY_ICONS || { glyphs: {}, map: {}, build: function () { return null; } };
  var colorByName = {}, whyByName = {}, catByName = {};
  var allGenes = [];
  P.categories.forEach(function (c) {
    colorByName[c.name] = c.color; whyByName[c.name] = c.whyItMatters; catByName[c.name] = c;
    c.genes.forEach(function (g) { allGenes.push({ gene: g.gene, condition: g.condition, conditions: g.conditions || [], description: g.description || '', category: c.name }); });
  });

  function catIcon(name, cls) {
    return ICONS.build ? ICONS.build(name, cls || 'us-wtt2__icon') : null;
  }

  var GROUPS = window.US_PANEL_GROUPS;
  var families = GROUPS && GROUPS.group
    ? GROUPS.group(P.categories)
    : [{ name: '', color: '', cats: P.categories, count: 0 }];

  var soonNames = [];
  try {
    var soonEl = app.querySelector('.us-wtt2__soon-data');
    if (soonEl) soonNames = JSON.parse(soonEl.textContent) || [];
  } catch (e) { soonNames = []; }
  var detailOn = app.getAttribute('data-gene-detail') !== 'off';
  var availLabel = app.getAttribute('data-avail-label') || 'Available now';
  var soonLabel = app.getAttribute('data-soon-label') || 'Coming soon';
  var soonNote = app.getAttribute('data-soon-note') || '';
  var geneUrlBase = app.getAttribute('data-gene-url-base') || '';
  var buyTpl = app.querySelector('.us-wtt2__buy-tpl');
  if (buyTpl && !(buyTpl.content && buyTpl.content.firstElementChild)) buyTpl = null;
  var genePages = {};
  try {
    var pagesEl = app.querySelector('.us-wtt2__pages-data');
    if (pagesEl) JSON.parse(pagesEl.textContent).forEach(function (hnd) { genePages[hnd] = true; });
  } catch (e) { genePages = {}; }

  var state = { q: '' };
  var pendingScroll = null;

  function h(tag, attrs, kids) {
    var e = document.createElement(tag);
    if (attrs) for (var k in attrs) {
      if (k === 'class') e.className = attrs[k];
      else if (k === 'text') e.textContent = attrs[k];
      else e.setAttribute(k, attrs[k]);
    }
    if (kids) (Array.isArray(kids) ? kids : [kids]).forEach(function (c) { if (c) e.appendChild(typeof c === 'string' ? document.createTextNode(c) : c); });
    return e;
  }

  app.innerHTML = '';
  var catObserver = null;
  var revealObserver = null;

  var layout = h('div', { 'class': 'us-wtt2__layout' });

  var sidebar = h('aside', { 'class': 'us-wtt2__sidebar' });
  var sideInner = h('div', { 'class': 'us-wtt2__sidebar-inner' });

  var searchWrap = h('div', { 'class': 'us-wtt2__search' });
  var searchInput = h('input', { type: 'search', placeholder: 'Search genes or conditions', 'aria-label': 'Search genes or conditions' });
  var t;
  searchInput.addEventListener('input', function () { clearTimeout(t); t = setTimeout(function () { state.q = searchInput.value; renderResults(); }, 120); });
  searchWrap.appendChild(searchInput);
  sideInner.appendChild(searchWrap);

  var jump = h('nav', { 'class': 'us-wtt2__jump', 'aria-label': 'Jump to category' });
  jump.appendChild(h('p', { 'class': 'us-wtt2__jump-label' }, availLabel));
  var chipByCat = {};
  var jumpChips = h('div', { 'class': 'us-wtt2__jump-chips' });
  families.forEach(function (fam) {
    fam.cats.forEach(function (c) {
      var chip = h('button', { 'class': 'us-wtt2__jump-chip', type: 'button' }, c.name);
      chip.addEventListener('click', function () {
        if (state.q) { state.q = ''; searchInput.value = ''; pendingScroll = c.name; renderResults(); }
        else { scrollToCat(c.name); }
      });
      chipByCat[c.name] = chip;
      jumpChips.appendChild(chip);
    });
  });
  jump.appendChild(jumpChips);
  if (soonNames.length) {
    jump.appendChild(h('p', { 'class': 'us-wtt2__jump-label us-wtt2__jump-label--soon' }, soonLabel));
    var soonChips = h('div', { 'class': 'us-wtt2__jump-chips' });
    soonNames.forEach(function (n) {
      soonChips.appendChild(h('button', { 'class': 'us-wtt2__jump-chip', type: 'button', disabled: 'disabled' }, n));
    });
    jump.appendChild(soonChips);
  }
  sideInner.appendChild(jump);
  sidebar.appendChild(sideInner);

  var results = h('div', { 'class': 'us-wtt2__results' });

  layout.appendChild(sidebar);
  layout.appendChild(results);
  app.appendChild(layout);

  var srStatus = h('p', { 'class': 'us-visually-hidden', role: 'status' });
  app.appendChild(srStatus);

  var tint = (root0 && root0.getAttribute('data-us-tint')) || 'cool';
  var overlay = h('div', { 'class': 'us-root us-wtt2__overlay', 'data-us-tint': tint, hidden: 'hidden' });
  var backdrop = h('div', { 'class': 'us-wtt2__backdrop' });
  var drawer = h('aside', { 'class': 'us-wtt2__drawer', role: 'dialog', 'aria-modal': 'true', 'aria-label': 'Gene detail', tabindex: '-1' });
  var drawerClose = h('button', { 'class': 'us-wtt2__drawer-close', type: 'button', 'aria-label': 'Close' }, '✕');
  var drawerInner = h('div', { 'class': 'us-wtt2__drawer-inner' });
  drawer.appendChild(drawerClose); drawer.appendChild(drawerInner);
  if (buyTpl) drawer.appendChild(h('div', { 'class': 'us-wtt2__drawer-foot' }, [buyTpl.content.firstElementChild.cloneNode(true)]));
  overlay.appendChild(backdrop); overlay.appendChild(drawer);
  if (detailOn) document.body.appendChild(overlay);

  var lastFocus = null;
  var closePending = null;
  function openDrawer() {
    lastFocus = document.activeElement;
    if (closePending) { drawer.removeEventListener('transitionend', closePending); closePending = null; }
    overlay.hidden = false;
    void overlay.offsetWidth;
    overlay.classList.add('is-open');
    if (!gutterStable) document.body.style.paddingRight = (window.innerWidth - document.documentElement.clientWidth) + 'px';
    document.body.style.overflow = 'hidden';
    drawerClose.focus();
  }
  function closeDrawer() {
    if (overlay.hidden || !overlay.classList.contains('is-open')) return;
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
    var dur = parseFloat(getComputedStyle(drawer).transitionDuration) || 0;
    if (reduce || dur === 0) { overlay.hidden = true; return; }
    var onEnd = function () {
      drawer.removeEventListener('transitionend', onEnd);
      if (closePending === onEnd) closePending = null;
      if (!overlay.classList.contains('is-open')) overlay.hidden = true;
    };
    closePending = onEnd;
    drawer.addEventListener('transitionend', onEnd);
    setTimeout(onEnd, dur * 1000 + 120);
  }
  var listTitle = app.getAttribute('data-list-title') || document.title;
  var listUrl = app.getAttribute('data-list-url') || '';
  var landedTitle = document.title;
  var onGeneUrl = false;
  function geneHref(g) {
    var hnd = g.gene.toLowerCase();
    return geneUrlBase && genePages[hnd] && window.history && history.pushState ? geneUrlBase + hnd : '';
  }
  function requestClose() {
    var st = history.state;
    if (onGeneUrl && st && st.wttGene && !st.landed) { history.back(); return; }
    if (onGeneUrl && st && st.landed && listUrl) history.pushState(null, '', listUrl);
    onGeneUrl = false;
    document.title = listTitle;
    closeDrawer();
  }
  window.addEventListener('popstate', function (e) {
    var want = e.state && e.state.wttGene;
    var hit = want && allGenes.filter(function (g) { return g.gene === want; })[0];
    if (hit) { openGene(hit, catByName[hit.category], true); return; }
    onGeneUrl = false;
    document.title = listTitle;
    closeDrawer();
  });
  backdrop.addEventListener('click', requestClose);
  drawerClose.addEventListener('click', requestClose);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !overlay.hidden) requestClose(); });
  overlay.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var f = drawer.querySelectorAll('button, a[href], [tabindex]:not([tabindex="-1"])');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
    else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
  });

  function geneRow(g, cat) {
    var color = (cat && cat.color) || colorByName[g.category] || 'var(--us-hairline-strong)';
    var row = detailOn
      ? h('button', { 'class': 'us-wtt2__gene', type: 'button', style: '--accent:' + color })
      : h('div', { 'class': 'us-wtt2__gene us-wtt2__gene--flat', style: '--accent:' + color });
    if (!reduce) row.classList.add('is-anim');
    row.appendChild(h('span', { 'class': 'us-wtt2__gene-sym' }, g.gene));
    row.appendChild(h('span', { 'class': 'us-wtt2__gene-cond' }, g.condition));
    if (detailOn) {
      row.appendChild(h('span', { 'class': 'us-wtt2__gene-chev', 'aria-hidden': 'true' }));
      row.addEventListener('click', function () { openGene(g, cat || catByName[g.category]); });
    }
    return row;
  }
  function geneList(genes, cat) {
    var wrap = h('div', { 'class': 'us-wtt2__genes' });
    genes.forEach(function (g) { wrap.appendChild(geneRow(g, cat)); });
    return wrap;
  }
  function trackGene(g, cat) {
    try {
      var amp = window.amplitude;
      if (!amp || typeof amp.track !== 'function') return;
      amp.track('Gene Detail Opened', {
        gene: g.gene,
        category: (cat && cat.name) || g.category || '',
        conditions: (g.conditions && g.conditions.length ? g.conditions : (g.condition ? [g.condition] : [])).join(', '),
        source: state.q ? 'search' : 'browse'
      });
    } catch (e) {}
  }
  function openGene(g, cat, fromHistory) {
    drawerInner.innerHTML = '';
    geneDetailContent(g, cat).forEach(function (n) { drawerInner.appendChild(n); });
    drawerInner.scrollTop = 0;
    var href = geneHref(g);
    if (href && !fromHistory) {
      if (onGeneUrl) history.replaceState({ wttGene: g.gene }, '', href);
      else history.pushState({ wttGene: g.gene }, '', href);
    }
    onGeneUrl = !!(href && history.state && history.state.wttGene);
    if (onGeneUrl) document.title = history.state.landed ? landedTitle : g.gene + ' | ' + listTitle;
    if (overlay.hidden || !overlay.classList.contains('is-open')) openDrawer();
    trackGene(g, cat);
  }
  function categorySection(c) {
    var section = h('section', { 'class': 'us-wtt2__section', 'data-cat-name': c.name });
    var head = h('div', { 'class': 'us-wtt2__section-head' });
    var hIconWrap = h('span', { 'class': 'us-wtt2__cathead-icon' });
    var hIc = catIcon(c.name); if (hIc) hIconWrap.appendChild(hIc);
    head.appendChild(hIconWrap);
    head.appendChild(h('h2', { 'class': 'us-wtt2__catname' }, [
      c.name,
      h('sup', { 'class': 'us-wtt2__catcount' }, [
        '(' + c.count,
        h('span', { 'class': 'us-visually-hidden' }, ' genes'),
        ')'
      ])
    ]));
    section.appendChild(head);
    section.appendChild(geneList(c.genes, c));
    return section;
  }
  function listView() {
    var wrap = h('div', { 'class': 'us-wtt2__browse' });
    families.forEach(function (fam) {
      fam.cats.forEach(function (c) { wrap.appendChild(categorySection(c)); });
    });
    wrap.appendChild(h('div', { 'class': 'us-wtt2__tail', 'aria-hidden': 'true' }));
    return wrap;
  }
  function sizeTailSpacer() {
    var tail = results.querySelector('.us-wtt2__tail');
    if (!tail) return;
    var secs = results.querySelectorAll('.us-wtt2__section');
    if (!secs.length) return;
    tail.style.height = '0px';
    var lastTop = secs[secs.length - 1].getBoundingClientRect().top;
    var endTop = tail.getBoundingClientRect().top;
    tail.style.height = Math.max(0, Math.round(window.innerHeight - stickyTopInset() - (endTop - lastTop))) + 'px';
  }
  function stickyTopInset() {
    var hdr = document.querySelector('.shopify-section-group-header-group, .shopify-section-group-us-preview-header-group');
    var h = hdr ? hdr.getBoundingClientRect().height : 0;
    if (!h) {
      var navh = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--us-nav-h'));
      h = navh || 84;
    }
    var pinned = getComputedStyle(searchWrap).position === 'sticky' ? searchWrap.offsetHeight : 0;
    return h + 16 + pinned;
  }
  var jumping = false;
  function cancelJump() {
    if (!jumping) return;
    jumping = false;
    clearInterval(scrollToCat._iv);
    clearTimeout(scrollToCat._t);
  }
  ['wheel', 'touchstart'].forEach(function (ev) {
    window.addEventListener(ev, cancelJump, { passive: true });
  });
  window.addEventListener('keydown', function (e) {
    if (['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' '].indexOf(e.key) > -1) cancelJump();
  });
  function scrollToCat(name) {
    var secs = results.querySelectorAll('.us-wtt2__section');
    var target = null;
    for (var i = 0; i < secs.length; i++) {
      if (secs[i].getAttribute('data-cat-name') === name) { target = secs[i]; break; }
    }
    if (!target) return;
    jumping = true;
    setActiveChip(name);
    var y = target.getBoundingClientRect().top + window.pageYOffset - stickyTopInset();
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    clearInterval(scrollToCat._iv);
    var lastY = NaN, still = 0, stable = 0;
    scrollToCat._iv = setInterval(function () {
      var cy = Math.round(window.pageYOffset);
      if (cy === lastY) {
        if (++still >= 3) {
          var diff = Math.round(target.getBoundingClientRect().top - stickyTopInset());
          if (Math.abs(diff) > 3) { window.scrollBy({ top: diff, left: 0, behavior: 'auto' }); still = 0; stable = 0; }
          else if (++stable >= 2) { clearInterval(scrollToCat._iv); setActiveChip(name); jumping = false; }
        }
      } else { still = 0; stable = 0; }
      lastY = cy;
    }, 60);
    clearTimeout(scrollToCat._t);
    scrollToCat._t = setTimeout(function () { clearInterval(scrollToCat._iv); setActiveChip(name); jumping = false; }, 3200);
  }
  function setActiveChip(name) {
    for (var k in chipByCat) {
      if (!Object.prototype.hasOwnProperty.call(chipByCat, k)) continue;
      var on = k === name;
      chipByCat[k].classList.toggle('is-active', on);
      if (on) chipByCat[k].setAttribute('aria-current', 'true'); else chipByCat[k].removeAttribute('aria-current');
    }
  }
  function wireRowReveal() {
    if (reduce || !('IntersectionObserver' in window)) return;
    if (revealObserver) revealObserver.disconnect();
    revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); revealObserver.unobserve(e.target); }
      });
    }, { threshold: 0.35, rootMargin: '0px 0px -8% 0px' });
    results.querySelectorAll('.us-wtt2__gene.is-anim').forEach(function (r) { revealObserver.observe(r); });
  }

  function wireJump() {
    setActiveChip(null);
    if (!('IntersectionObserver' in window)) return;
    if (catObserver) catObserver.disconnect();
    catObserver = new IntersectionObserver(function (entries) {
      if (jumping) return;
      entries.forEach(function (e) { if (e.isIntersecting) setActiveChip(e.target.getAttribute('data-cat-name')); });
    }, { rootMargin: '-15% 0px -75% 0px', threshold: 0 });
    results.querySelectorAll('.us-wtt2__section').forEach(function (s) { catObserver.observe(s); });
  }

  function geneDetailContent(g, cat) {
    var nodes = [];
    nodes.push(h('h2', { 'class': 'us-wtt2__gd-sym' }, g.gene));
    var tags = (g.conditions && g.conditions.length) ? g.conditions : (g.condition ? [g.condition] : []);
    if (tags.length) {
      nodes.push(h('p', { 'class': 'us-wtt2__gd-tags-label' }, 'Associated conditions:'));
      var tagWrap = h('div', { 'class': 'us-wtt2__gd-tags' });
      tags.forEach(function (c) { tagWrap.appendChild(h('span', { 'class': 'us-wtt2__gd-tag' }, c)); });
      nodes.push(tagWrap);
    }
    var card = h('div', { 'class': 'us-wtt2__gd-card' });
    if (g.description) {
      card.appendChild(h('h3', { 'class': 'us-wtt2__dt' }, 'About this gene'));
      card.appendChild(h('p', { 'class': 'us-wtt2__dp' }, g.description));
    }
    (g.conditions || []).filter(function (c) { return condDesc[c]; }).forEach(function (c) {
      card.appendChild(h('h3', { 'class': 'us-wtt2__dt' }, c));
      card.appendChild(h('p', { 'class': 'us-wtt2__dp' }, condDesc[c]));
    });
    var why = cat ? cat.whyItMatters : whyByName[g.category];
    if (why) {
      card.appendChild(h('h3', { 'class': 'us-wtt2__dt' }, 'Why it matters'));
      card.appendChild(h('p', { 'class': 'us-wtt2__dp' }, why));
    }
    nodes.push(card);

    return nodes;
  }

  function searchView(q) {
    var ql = q.toLowerCase();
    var matches = allGenes.filter(function (g) {
      return g.gene.toLowerCase().indexOf(ql) > -1 ||
        g.condition.toLowerCase().indexOf(ql) > -1 ||
        g.conditions.some(function (c) { return c.toLowerCase().indexOf(ql) > -1; });
    });
    var wrap = h('div', { 'class': 'us-wtt2__browse' });
    wrap.appendChild(h('p', { 'class': 'us-wtt2__searchcount' }, matches.length + (matches.length === 1 ? ' gene' : ' genes') + ' matching “' + q + '”'));
    if (matches.length) wrap.appendChild(geneList(matches));
    else wrap.appendChild(h('p', { 'class': 'us-wtt2__empty' }, 'No genes or conditions match that search.'));
    return wrap;
  }

  function keepResultsInView() {
    var inset = stickyTopInset();
    var top = results.getBoundingClientRect().top;
    if (top >= inset - 1) return;
    window.scrollTo({ top: Math.max(0, top + window.pageYOffset - inset), behavior: 'smooth' });
  }

  function renderResults() {
    results.innerHTML = '';
    if (catObserver) { catObserver.disconnect(); catObserver = null; }
    var q = state.q.trim();
    srStatus.textContent = q ? 'Search results for ' + q : 'Showing the full gene list';
    jump.style.display = q ? 'none' : '';
    if (q) { results.appendChild(searchView(q)); wireRowReveal(); keepResultsInView(); return; }
    results.appendChild(listView());
    wireJump();
    wireRowReveal();
    sizeTailSpacer();
    if (pendingScroll) { var target = pendingScroll; pendingScroll = null; scrollToCat(target); }
  }

  var _resizeT;
  window.addEventListener('resize', function () {
    clearTimeout(_resizeT);
    _resizeT = setTimeout(function () { if (!state.q.trim()) sizeTailSpacer(); }, 150);
  });

  renderResults();
  if (detailOn) {
    try {
      var landing = app.getAttribute('data-open-gene');
      var wanted = landing || new URLSearchParams(location.search).get('gene');
      if (landing) {
        var own = allGenes.filter(function (g) { return g.gene === landing; })[0];
        if (own) {
          history.replaceState({ wttGene: own.gene, landed: true }, '', location.href);
          overlay.classList.add('is-instant');
          openGene(own, catByName[own.category], true);
          requestAnimationFrame(function () { requestAnimationFrame(function () { overlay.classList.remove('is-instant'); }); });
        } else {
          var fallback = document.querySelector('.gene-page');
          if (fallback) fallback.style.display = '';
        }
      } else if (wanted) {
        var hit = allGenes.filter(function (g) { return g.gene.toLowerCase() === wanted.toLowerCase(); })[0];
        if (hit) openGene(hit, catByName[hit.category], true);
      }
    } catch (e) {}
  }
  }
})();
